<p-dialog
  header="Nuovo Soggetto"
  [modal]="true"
  [(visible)]="visible"
  [closable]="true"
  [closeOnEscape]="false"
  [style]="{ width: '48rem' }"
  (onHide)="onDialogHide()">
  <form [formGroup]="form" class="p-fluid">
    <div class="field">
      <label for="soggetto-tipo">Tipo*</label>
      <p-dropdown
        id="soggetto-tipo"
        formControlName="tipoSoggettoId"
        [options]="tipiSoggetto"
        optionLabel="label"
        optionValue="value"
        placeholder="Seleziona..."
        [showClear]="true">
      </p-dropdown>
    </div>
    <div class="field" *ngIf="tipoSoggetto">
      <label for="soggetto-nome">{{ nomeLabel }}*</label>
      <input id="soggetto-nome" type="text" pInputText formControlName="nome" />
    </div>
    <div class="field" *ngIf="isPersonaFisica">
      <label for="soggetto-cognome">Cognome*</label>
      <input id="soggetto-cognome" type="text" pInputText formControlName="cognome" />
    </div>
    <div class="field" *ngIf="isPersonaFisica || isPersonaGiuridica">
      <label for="soggetto-cf">
        {{ isPersonaGiuridica ? 'Codice Fiscale / Partita IVA' : 'Codice fiscale' }}
      </label>
      <input id="soggetto-cf" type="text" pInputText formControlName="codiceFiscale" />
    </div>
    <div class="field" *ngIf="isPai">
      <label for="soggetto-denom-aoo">Denominazione Amministrazione AOO / Codice IPA AOO*</label>
      <input id="soggetto-denom-aoo" type="text" pInputText formControlName="denominazioneAoo" />
    </div>
    <div class="field" *ngIf="isPae">
      <label for="soggetto-indirizzi">Indirizzi digitali di riferimento*</label>
      <input id="soggetto-indirizzi" type="text" pInputText formControlName="indirizziDigitaliRiferimento" />
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-text"
      label="Annulla"
      (click)="close()"
      [disabled]="saving"></button>
    <button
      pButton
      type="button"
      label="Salva"
      (click)="save()"
      [disabled]="form.invalid || saving"></button>
  </ng-template>
</p-dialog>
